export const loadScript = (
  url: string,
  onLoad?: (script: HTMLScriptElement) => void,
  onError?: (script: HTMLScriptElement) => void,
) =>
  new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    script.async = true;
    script.onload = () => {
      onLoad?.(script);
      resolve('Load Successful');
    };
    script.onerror = () => {
      onError?.(script);
      reject('Load Failed');
    };
    document.body.appendChild(script);
  });
